import React from "react";
import { useSelector } from "react-redux";

import { StoreType } from "../../../utils/types";

export const useFilterData = () => {
    const isWorkerSubTypeEnabled = useSelector(
        (state: StoreType) => state.user.userData.workerSubTypeEnabled
    );

    return {
        isWorkerSubTypeEnabled,
    };
};
